<template>
  <router-link
    class="notification row no-gutters align-items-center nounderline"
    :to="`/p/case/${entity.patient_case_id}`"
  >
    <!-- <div class="col-auto text-primary border-right p-3">
      <DiagnosesIcon></DiagnosesIcon>
    </div> -->
    <div class="col mb-2 p-3">
      <small class="text-muted">
        {{ $t(action) }}
      </small>
      <h4>
        {{ $t(entity.type) }}
        <small class="text-muted d-block">
          {{ entity.published_at | moment("ddd, DD MMMM, HH:mm") }}
        </small>
      </h4>
      <ul class="list-unstyled">
          <li
            class="m-0 d-block text-muted"
            v-for="condition of entity.conditions"
            :key="condition.code"
        >
            <small>{{ condition.name[authLocale] }} ({{condition.code}})</small>
        </li>
      </ul>
      <p
        class="m-0 d-block text-muted"
        v-if="entity.comment "
      >
        {{ entity.comment }}
      </p>
    </div>
    <div class="col-12 w-100"></div>
  </router-link>
</template>
<script>
// import DiagnosesIcon from '@/components/Icons/Diagnoses'
import { mapGetters } from 'vuex'
export default {
  // components: {
  //   DiagnosesIcon
  // },
  props: {
    entity: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale'
    })
  }
}
</script>
<style lang="scss">
.notification {
  .month {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 80px;
    font-size: 0.75em;
  }
  .day {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 44px;
    font-size: 2em;
  }
  svg {
    width: 75px;
    // height: 100px;
  }
}
</style>
<i18n>
{
  "ka": {
      "DiagnosisPublished": "გამოქვეყნდა",
      "final": "საბოლოო დიაგნოზი",
      "preliminary": "წინასწარი დიაგნოზი"
  },
  "en": {
      "DiagnosisPublished": "Published",
      "final": "Final Diagnosis",
      "preliminary": "Preliminary Diagnosis"
  }
}
</i18n>
